var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('reports-list',{attrs:{"is-admin":_vm.loggedInEmployee.isAdmin,"reports":_vm.availableReports}}),_c('v-footer',{attrs:{"color":"","app":"","height":"55"}},[_c('v-spacer'),_c('footer-back-btn',{on:{"click":_vm.cancel}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }